import type { ReactNode } from 'react';
// @ts-ignore
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { RentalManagerEnvironmentProvider } from '../components';
import type { InitializeBrowserOptions } from './browserEnv';
import { initializeBrowser } from './browserEnv';
import { SplitProvider } from '@zg-rentals/split';
import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';

export const renderClientIndex = ({
  app,
  appName,
  onBootstrapRegister,
}: InitializeBrowserOptions & { app: ReactNode }) => {
  const container = document.getElementById('app-root');
  const root = createRoot(container!);
  const environment = initializeBrowser({
    appName,
    zgApi: __API__!,
    buildNumber: __BUILD_NUMBER__,
    onBootstrapRegister,
  });

  root.render(
    <RpErrorBoundary>
      <SplitProvider>
        <RentalManagerEnvironmentProvider environment={environment}>
          <BrowserRouter>{app}</BrowserRouter>
        </RentalManagerEnvironmentProvider>
      </SplitProvider>
    </RpErrorBoundary>,
  );
};
